import { Crosswalk } from '@kinetic-ui/data-layer';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Alert } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { RecursivePartial } from 'types';
import { LocationFormContext } from '../../context';
import { CrosswalkForm } from './CrosswalkForm/CrosswalkForm';
import { useSelectedCrosswalk } from './useSelectedCrosswalk';

export const CrosswalkList = () => {
  const { values } = useContext(LocationFormContext);
  const crosswalks = useMemo(() => values?.crosswalks ?? [], [values?.crosswalks]);

  const { t } = useTranslation('locations');
  const { selectedCrosswalk, setSelectedCrosswalk } = useSelectedCrosswalk();

  return (
    <>
      {crosswalks.length === 0 ? (
        <Alert severity='warning'>
          {t('emptyLocationObjectMessage', { object: 'Crosswalks' })}
        </Alert>
      ) : null}
      {crosswalks.map((crosswalk: RecursivePartial<Crosswalk>) => {
        return (
          <Accordion
            expanded={selectedCrosswalk?.id === crosswalk.id}
            key={crosswalk.id}
            onChange={(_, expanded) => setSelectedCrosswalk(expanded ? crosswalk : undefined)}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              {crosswalk.description}
            </AccordionSummary>
            <AccordionDetails>
              {selectedCrosswalk?.id === crosswalk.id && (
                <CrosswalkForm onClose={() => setSelectedCrosswalk(undefined)} />
              )}
            </AccordionDetails>
          </Accordion>
        );
      })}
    </>
  );
};
